import { Create, useForm } from "@refinedev/antd";
import {
  dateFormat,
  DayMonthYearHoursAndMinutes,
  errorNotification,
  successNotification,
} from "../../../../helpers";

import { Button, Col, Form, Input, Row, Space } from "antd";
import { AppImageUploader, AppTitle, EFileTypes } from "../../../../components";
import { v4 as randomId } from "uuid";
import { PhilosophyBlockCreate } from "../Philosophy-Create/Philosophy-Block-Create";
import { useMatch } from "react-router-dom";
import { PhilosophyCreateRequest } from "../../Lib/types";
import { useWatch } from "antd/es/form/Form";
import { useMemo } from "react";
import dayjs from "dayjs";

export const PhilosophyEdit = () => {
  const route = useMatch("/:parent/:action/:id");
  const id = route?.params.id;

  const { formProps, saveButtonProps, form, formLoading, onFinish } =
    useForm<PhilosophyCreateRequest>({
      resource: "philosophy",
      action: "edit",
      id: Number(id),
      dataProviderName: "philosophyDataProvider",
      redirect: "list",
      ...successNotification({
        successData: {
          message: "Философия успешно отредактирована",
          type: "success",
        },
      }),
      ...errorNotification({
        errorData: {
          errorKeys: [
            {
              errorCode: "channelPoints.invalid",
              message:
                "Невозможно добавить баллы без создания маркетингового канала",
            },
          ],
        },
      }),
    });

  const watchReleaseDate = useWatch("newsDate", form);
  const isPublic = useWatch("isPublic", form);

  const renderDate = useMemo(() => {
    if (watchReleaseDate === "Invalid Date") {
      return dateFormat();
    }
    return dateFormat(watchReleaseDate, DayMonthYearHoursAndMinutes);
  }, [watchReleaseDate]);

  const onSubmitForm = (values: any) => {
    onFinish({ ...values });
  };

  return (
    <Create
      isLoading={formLoading}
      title={
        <AppTitle
          isLoading={formLoading}
          canGoBack
          routerLink={"/league-info/philosophy"}
        >
          Редактирование философии
        </AppTitle>
      }
      breadcrumb={false}
      headerButtons={<></>}
      footerButtons={<></>}
      goBack={false}
    >
      <Form
        {...formProps}
        onFinish={onSubmitForm}
        initialValues={{
          newsDate: dayjs(),
          ...formProps.initialValues,
          leagueId:
            formProps.initialValues?.leagueId === null
              ? 0
              : formProps.initialValues?.leagueId,
        }}
        layout={"vertical"}
      >
        <Row gutter={24}>
          <Col span={12}>
            <Space size={16} direction="vertical" style={{ width: "100%" }}>
              <Form.Item
                name={"mainPhotoUrl"}
                label={"Изображение"}
                rules={
                  isPublic && [
                    {
                      required: true,
                      message: "Укажите изображение",
                    },
                  ]
                }
              >
                <AppImageUploader
                  type="NEWS"
                  entityId={`${randomId()}`}
                  serviceType={EFileTypes.NEWS}
                  cropperProps={{
                    modalTitle: "Редактировать изображение",
                  }}
                  uploadProps={{
                    multiple: false,
                    children: "Изображение",
                    listType: "picture-card",
                  }}
                />
              </Form.Item>

              <Form.Item
                label="Заголовок"
                rules={[
                  { required: true, message: "Укажите заголовок" },
                  {
                    min: 5,
                    max: 100,
                    message: "Заголовок может быть от 5 до 100 символов",
                  },
                ]}
                name={"title"}
              >
                <Input.TextArea rows={2} placeholder={"Укажите заголовок"} />
              </Form.Item>

              {/*isPublic*/}
              <PhilosophyBlockCreate form={form} isPublic={true} />

              <Space>
                <Button type={"primary"} htmlType={"submit"}>
                  Отредактировать
                </Button>
              </Space>
            </Space>
          </Col>
        </Row>
      </Form>
    </Create>
  );
};
